import { sortBy } from 'lodash';
import { useMemo } from 'react';
import { useSystemSettings } from 'providers/SystemSettingsProvider';
import OrganizationQuestionLocation from 'types/OrganizationQuestionLocation';
import OrganizationQuestionDto from 'types/api/OrganizationQuestionDto';

const useCustomQuestions = () => {
  const { organization_register_questions } = useSystemSettings();

  return useMemo(() => {
    const groupedQuestions: Record<OrganizationQuestionLocation, OrganizationQuestionDto[]> = {
      [OrganizationQuestionLocation.ORGANIZATION]: [],
      [OrganizationQuestionLocation.CONTACT]: [],
      [OrganizationQuestionLocation.TERMS]: [],
    };

    for (const question of organization_register_questions) {
      groupedQuestions[question.location].push(question);
    }

    for (const key of Object.keys(groupedQuestions)) {
      groupedQuestions[key as OrganizationQuestionLocation] = sortBy(
        groupedQuestions[key as OrganizationQuestionLocation],
        'priority',
      );
    }

    return groupedQuestions;
  }, [organization_register_questions]);
};

export default useCustomQuestions;
